export default "__VITE_ASSET__CmTRQ3aK__"